import server from "./server";

export const getLanguagesApi = async () => {
  const response = await server().get("/languages");
  return response.data;
};
